module.exports = __webpack_public_path__ + "img/icon_task.02a4a5a4.png";